'use client'

import { useSession } from '@marketplace-web/shared/session-data'

import { reloadPage } from '@marketplace-web/browser/browser-navigation-util'
import {
  declineComplaintResolved,
  continueConversationClicked,
} from '@marketplace-web/help-center-conversation-support/conversation-support-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import useHelpCenterSessionTracking from '@marketplace-web/help-center/help-center-session-tracking-util'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFeedbackType } from '@marketplace-web/help-center-conversation-support/help-center-automated-feedback-feature'

type Props = ConversationActionProps

const RefuseComplaintResolved = ({ title, primary, size, theme, inverse, action }: Props) => {
  const { user } = useSession()

  const { conversation } = useConversationContext()
  const conversationId = conversation?.id
  const { track } = useTracking()
  const { helpCenterSessionId } = useHelpCenterSessionTracking()

  async function continueConversation() {
    if (!user?.id || !conversationId || !helpCenterSessionId) return

    track(
      continueConversationClicked({
        helpCenterSessionId,
        threadId: conversationId.toString(),
        supportType: getFeedbackType(action),
      }),
    )

    await declineComplaintResolved(conversationId)

    reloadPage()
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      onClick={continueConversation}
    />
  )
}

export default RefuseComplaintResolved
